var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M476.69,419H123.586c-4.875,0-8.828-3.952-8.828-8.828l0,0c0-4.875,3.952-8.828,8.828-8.828H476.69   l8.828,8.828L476.69,419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M481.103,392.517H123.586c0,0,141.241-158.897,273.655-194.207c0,0-44.138,114.759,61.793,185.379   h22.069c2.438,0,4.414,1.976,4.414,4.414l0,0C485.517,390.541,483.541,392.517,481.103,392.517z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M131.87,204.354l3.425,10.27l10.826,0.084c1.402,0.011,1.983,1.8,0.855,2.632l-8.709,6.431   l3.266,10.322c0.423,1.336-1.099,2.442-2.239,1.627l-8.808-6.296l-8.808,6.296c-1.14,0.815-2.662-0.29-2.239-1.627l3.266-10.322   l-8.709-6.431c-1.128-0.833-0.546-2.621,0.855-2.632l10.826-0.084l3.425-10.27C129.546,203.025,131.427,203.025,131.87,204.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M131.609,63.152l2.779,8.332l8.783,0.068c1.137,0.009,1.609,1.46,0.694,2.136l-7.066,5.218   l2.649,8.374c0.343,1.084-0.891,1.981-1.817,1.32l-7.146-5.108l-7.146,5.108c-0.925,0.661-2.16-0.236-1.817-1.32l2.649-8.374   l-7.066-5.218c-0.915-0.676-0.443-2.127,0.694-2.136l8.783-0.068l2.779-8.332C129.724,62.073,131.249,62.073,131.609,63.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M65.067,114.711l2.779,8.332l8.783,0.068c1.137,0.009,1.609,1.46,0.694,2.136l-7.066,5.218   l2.649,8.374c0.343,1.084-0.891,1.981-1.817,1.32l-7.146-5.108l-7.146,5.108c-0.925,0.661-2.16-0.236-1.817-1.32l2.649-8.374   l-7.066-5.218c-0.915-0.676-0.443-2.127,0.694-2.136l8.783-0.068l2.779-8.332C63.182,113.632,64.708,113.632,65.067,114.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.197,111.196l2.138,6.412l6.759,0.052c0.875,0.007,1.238,1.124,0.534,1.643l-5.437,4.015   l2.039,6.444c0.264,0.834-0.686,1.525-1.398,1.016l-5.499-3.93l-5.499,3.93c-0.712,0.509-1.662-0.181-1.398-1.016l2.039-6.444   l-5.437-4.015c-0.704-0.52-0.341-1.637,0.534-1.643l6.759-0.052l2.138-6.412C177.746,110.366,178.92,110.366,179.197,111.196z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/TK.f2f95e983781d9644fa6b2584f376733.svg";
export { ForwardRef as ReactComponent };